import * as React from 'react';
import { theme } from '../../../../common/styles/theme';
import { IAppSwitcherProps } from './types';
import {
  APP_SWITCHER_APP,
  APP_SWITCHER_LANG,
  APP_SWITCHER_MIN_HIT,
  APP_SWITCHER_PADDING,
} from './constants';

// The LangMagic apps menu in the logo's place: an icon that opens a drop-down of all LangMagic apps
export const AppSwitcher: React.FC<IAppSwitcherProps> = ({
  size,
}) => {
  // the click area is wider than the icon: pull it left so the icon itself lines up with the edge
  const inset = Math.max(APP_SWITCHER_MIN_HIT, size + 2 * APP_SWITCHER_PADDING) / 2 - size / 2;

  return (
    <langmagic-switcher
      app={APP_SWITCHER_APP}
      size={size}
      lang={APP_SWITCHER_LANG}
      style={{
        // the menu's own font is Nunito Sans (unloaded here); a host style outranks the shadow :host rule
        fontFamily: theme.typography.fontFamily,
        flexShrink: 0,
        marginLeft: -inset,
        // the icon box before the script defines the element, so the header doesn't shift
        minWidth: size + 2 * inset,
        minHeight: size + 2 * inset,
      }}
    />
  );
};
